import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from "react";
import { ToastProvider } from "../../ToastProvider";
import Toast from "../Toast";
import useContainerAnimations from "./hooks/useContainerAnimations";
import { getContainerAnimationStyles, getToastAnimationStyles } from "./logic";
import { jsx as _jsx } from "react/jsx-runtime";
function AnimatedToast(_ref) {
  var toast = _ref.toast,
    setHover = _ref.setHover,
    removeToast = _ref.removeToast;
  var id = toast.id,
    type = toast.type,
    title = toast.title,
    message = toast.message,
    hideIcon = toast.options.hideIcon;
  var _useContainerAnimatio = useContainerAnimations(toast, getContainerAnimationStyles, getToastAnimationStyles),
    _useContainerAnimatio2 = _slicedToArray(_useContainerAnimatio, 3),
    containerStyles = _useContainerAnimatio2[0],
    toastStyles = _useContainerAnimatio2[1],
    toastRef = _useContainerAnimatio2[2];
  var onClose = useCallback(function () {
    return removeToast(id);
  }, [id, removeToast]);
  return /*#__PURE__*/_jsx(ToastProvider, {
    toastType: type,
    children: /*#__PURE__*/_jsx("div", {
      onMouseEnter: function onMouseEnter() {
        return setHover(id, true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHover(id, false);
      },
      style: containerStyles,
      children: /*#__PURE__*/_jsx("div", {
        ref: toastRef,
        style: toastStyles,
        children: /*#__PURE__*/_jsx(Toast, {
          title: title,
          message: message,
          hideIcon: hideIcon,
          onClose: onClose
        })
      })
    })
  });
}
export default AnimatedToast;